import { render, staticRenderFns } from "./TeamOverviewTeam.vue?vue&type=template&id=bea919f2&scoped=true"
import script from "./TeamOverviewTeam.vue?vue&type=script&lang=js"
export * from "./TeamOverviewTeam.vue?vue&type=script&lang=js"
import style0 from "./TeamOverviewTeam.vue?vue&type=style&index=0&id=bea919f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea919f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bea919f2')) {
      api.createRecord('bea919f2', component.options)
    } else {
      api.reload('bea919f2', component.options)
    }
    module.hot.accept("./TeamOverviewTeam.vue?vue&type=template&id=bea919f2&scoped=true", function () {
      api.rerender('bea919f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/TeamOverviewTeam.vue"
export default component.exports